// types: dispatch - move to a new path | jump - jump to a scene that's not immediately next

const sourceDecisionData = (
  state = {
    "1": {
      question:
        "You sit down to begin planning Bill's memorial service. First, you must decide what type of service you should plan. Given Bill's background, there are a few obvious options.",
      options: [
        { text: "Roman Catholic funeral", conditions: {type: "dispatch", command: "ROMAN_CATHOLIC", index: "2"}, feedback: "A Roman Catholic funeral would perhaps have been a service that felt familiar to Bill, honoring his childhood faith tradition." },
        { text: "Military secular service", conditions: {type: "dispatch", command: "MILITARY", index: "2"}, feedback: "A military secular service would be a good way to honor Bill’s identity as a soldier and his distance from organized faith at the time of his death." },
        { text: "Something else", conditions: {type: "dispatch", command: "SOMETHING_ELSE", index: "2"}, feedback: "Good choice. Given Bill’s difficult relationships with Catholicism and the military, a less ritualized ceremony honors Bill’s values." },
      ],
      multipleSelect: false,
    },
    "2": {

    }
  },
  action
) => {
  if (action.type === "ROMAN_CATHOLIC") {
    let data = {
     "2": {
        question: `Who will lead this service?`,
        options: [
          {
            text: `Given that Bill's spiritual history involved being Roman Catholic, you decide to collaborate with a local priest.`,
            conditions: {type: null, command: ""}, feedback: "Given the specific qualifications needed to perform a Roman Catholic service, if you yourself are not already a Roman Catholic priest, you would need to collaborate with one in order to perform the ceremony."
          },
          {
            text: `Given that Bill felt disconnected from the Roman Catholic Church, you decide not to collaborate with a local priest but to hold an interdenominational service.`,
            conditions: { type: "dispatch", command: "SOMETHING_ELSE", index: "2"}, feedback: "This potentially creates more space for participants who are unfamiliar with Catholicism as well. "
          },
        ],
        multipleSelect: false,
      },
      "3": {
        question: `What role will you play as the chaplain?`,
        options: [
          { text: `Co-officiate the service with the priest`, conditions: {type: null, command: ""}, feedback: "This will require close collaboration with the Catholic priest, but knowing someone who is co-officiating the service may help the members of your group feel more comfortable as well."},
          { text: `Consult and advise the priest only`, conditions: {type: null, command: ""}, feedback: "Because you knew Bill, your consultation about the service will be important. It may also be important for members of the Sunday morning discussion group to hear from you at some point in the service, such as during the eulogy, or to participate themselves in some way (i.e. as readers)." },
          { text: `Audience member`, conditions: {type: null, command: ""}, feedback: "Not holding a role in the service will allow you to be available for pastoral care throughout the service, or to de-escalate if anyone has a difficult time grieving." },
        ],
        multipleSelect: false,
      },
      "4": {
        question: `Who do you anticipate will attend? (select all that apply)`,
        options: [
          { text: `Bill's Sunday morning discussion group`, conditions: {type: "end", command: "SET_ACTIVE_SCENE"}, feedback:"Because memorial services are at least as much a ritual for the living as the dead, consider who will most need a space to process Bill’s death. You might also consider inter- and intra-group dynamics. Are there places conflict or different needs for grieving might emerge?"  },
          { text: `The shelter group`, conditions: {type: "end", command: "SET_ACTIVE_SCENE"}, feedback:"Bill's peers at the shelter may be grieving his death and want a space to honor him."   },
          { text: `Other ministers who cared for Bill`, conditions: {type: "end", command: "SET_ACTIVE_SCENE"}, feedback:"Even though Bill had a tenuous relationship with religion, other ministers in Bill's life may wish to attend. "  },
        ],
        multipleSelect: true,
      },
      "5": {
        question: `What worlds will be used?`,
        options: [
          { text: `The Roman Missal`, conditions: {type: null, command: ""}, feedback: "If using the Roman Missal, make sure to create a bulletin with the words and gestures included, so that those who are not familiar with it can follow along and participate. Consider also including a time for the community to collectively eulogize Bill during an open space for reflection."},
          {
            text: `A combination of the Roman Missal and other words written by you and the priest`,
            conditions: {type: null, command: ""},feedback: "Be sure to create a bulletin with the words and gestures included, so that the audience can follow along and participate. Consider also including a time for the community to collectively eulogize Bill during an open space for reflection."
          },
          {
            text: `You will give community members a time to eulogize Bill`,
            conditions: {type: null, command: ""}, feedback: "Regardless of what words are used during the ceremony, community members should be given a chance to share their reflections about Bill, or about loss more generally. Keep in mind that these reflections may not always seem relevant, but because one loss can bring up other losses in a person’s life, it is important for people to have the space to share."
          },
        ],
        multipleSelect: false,
      },
      "6": {
        question: `What objects will be used?`,
        options: [
          {
            text: `Typical objects used in a Roman Catholic funeral (bread, wine, etc)`,
            conditions: {type: null, command: "", feedback: " If you are unfamiliar with what objects are required, be sure to check in with the Roman Catholic priest. Consider also including any objects that have special significance for Bill."},
          },
          { text: `Objects of special significance to Bill`, conditions: {type: null, command: ""}, feedback: "Good choice- these objects help to honor Bill’s unique life, and can be a comfort to those who knew him and knew what objects were significant to him. Be sure to check with the Roman Catholic priest as well, in case there are any objects that are necessary for the Roman Catholic service (such as bread and wine)." },
        ],
        multipleSelect: false,
      },
      "7": {
        question: `What actions will be performed?`,
        options: [
          { text: `You will strictly follow the Roman Missal`, conditions: {type: null, command: ""}, feedback: "If using the Roman Missal, make sure to create a bulletin with the words and gestures included, so that those who are not familiar with it can follow along and participate. Consider also including a time for the community to collectively eulogize Bill during an open space for reflection." },
          {
            text: `You will incorporate military elements to honor Bill's service`,
            conditions: {type: null, command: ""}, feedback: "Including military elements may be a comfort to other veterans who come to the service, knowing that Bill (and their) service is honored by the community.",
          },
          {
            text: `You will give community members a time to eulogize Bill`,
            conditions: {type: null, command: ""}, feedback: "Regardless of the other ritual aspects of the ceremony, community members should be given a chance to share their reflections about Bill, or about loss more generally. Keep in mind that these reflections may not always seem relevant, but because one loss can bring up other losses in a person’s life, it is important for people to have the space to share."
          },
        ],
        multipleSelect: false,
      },
      "8": {
        question: `Where will the ritual be held?`,
        options: [
          { text: `A local Catholic Church`, conditions: {type: "end", command: "SET_ACTIVE_SCENE"}, feedback: "Check with the church ahead of time regarding any accessibility issues, including the unique needs for members of the Sunday morning discussion group."},
          {
            text: `The space where the Sunday discussion group meets`,
            conditions: {type: "end", command: "SET_ACTIVE_SCENE"}, feedback: "This will likely be the most inviting, accessible space for those in the Sunday group.",
          },
        ],
        multipleSelect: false,
      },
    };
    return data;
  } else if (action.type === "MILITARY") {
    let data = {
     "2": {
        question: `Who will lead this service?`,
        options: [
          {
            text: `You, the chaplain`,
            conditions: { type: null, command: "" },
            feedback: "Because you were Bill’s chaplain at the end of his life, you are an appropriate person to lead this service."
          },
          {
            text: `You and a group from Bill's Sunday morning discussion group`,
            conditions: {type: null, command: ""}, feedback: "Being part of a team creating the service may be empowering to members of the group, and could feel like a special way to honor Bill."
          },
          { text: `A military chaplain`, conditions: {type: null, command: ""}, feedback: "If you do not have a military background, collaborating with a military chaplain may provide useful insight and direction." },
        ],
        multipleSelect: false,
      },
      "3": {
        question: `What role will you play as the chaplain?`,
        options: [
          {
            text: `Co-officiate the service with the military chaplain`,
            conditions: {type: null, command: ""}, feedback: "If you do not have a military background, collaborating with a military chaplain may provide useful insight and direction."
          },
          {
            text: `Consult and advise the military chaplain only`,
            conditions: {type: null, command: ""}, feedback: "Because you knew Bill, your insight and guidance will be an important aspect of this service honoring his unique life."
          },
          { text: `Audience member`, conditions: {type: null, command: ""}, feedback: "Not holding a role in the service will allow you to be available for pastoral care throughout the service, or to de-escalate if anyone has a difficult time grieving." },
        ],
        multipleSelect: false,
      },
      "4": {
        question: `Who do you anticipate will attend?`,
        options: [
          { text: `Bill's Sunday morning discussion group`, conditions: {type: "end", command: "SET_ACTIVE_SCENE"}, feedback:"Because memorial services are at least as much a ritual for the living as the dead, consider who will most need a space to process Bill’s death. You might also consider inter- and intra-group dynamics. Are there places conflict or different needs for grieving might emerge?"  },
          { text: `The shelter group`, conditions: {type: "end", command: "SET_ACTIVE_SCENE"}, feedback:"Bill's peers at the shelter may be grieving his death and want a space to honor him."   },
          { text: `Other ministers who cared for Bill`, conditions: {type: "end", command: "SET_ACTIVE_SCENE"}, feedback:"Even though Bill had a tenuous relationship with religion, other ministers in Bill's life may wish to attend. "  },
        ],
        multipleSelect: true,
      },
      "5": {
        question: `What words will be used?`,
        options: [
          { text: `Standard military funeral`, conditions: {type: null, command: ""}, feedback: "Be sure to create a bulletin with the words and gestures included, so that those who are not familiar with a military secular ritual can follow along and participate. Consider also including a time for the community to collectively eulogize Bill during an open space for reflection." },
          {
            text: `A combination of the military funeral and other words written by you and the military chaplain`,
            conditions: {type: null, command: ""}, feedback: "Be sure to create a bulletin with the words and gestures included, so that participants can follow along. Consider also including a time for the community to collectively eulogize Bill during an open space for reflection."
          },
          {
            text: `You will give community members a time to eulogize Bill`,
            conditions: {type: null, command: ""}, feedback: "Regardless of the other ritual aspects of the ceremony, community members should be given a chance to share their reflections about Bill, or about loss more generally. Keep in mind that these reflections may not always seem relevant, but because one loss can bring up other losses in a person’s life, it is important for people to have the space to share."
          },
        ],
        multipleSelect: false,
      },
      "6": {
        question: `What objects will be used?`,
        options: [
          {
            text: `Typical objects used in military funeral (flag, guns, etc)`,
            conditions: {type: null, command: ""}, feedback: "If you are unfamiliar with what objects are required for a military secular service, be sure to check in with the military chaplain. Consider also including any objects that have special significance for Bill. For example, dogtags often become important objects for veterans. Some might even consider them sacred. If you lost a friend in battle, you may carry their dogtag with you or be the one to deliver it to the family."
          },
          { text: `Objects of special significance to Bill`, conditions: {type: null, command: ""}, feedback: " Good choice- these objects help to honor Bill’s unique life, and can be a comfort to those who knew him and knew what objects were significant to him. Be sure to check with the military chaplain as well, in case there are any objects that are necessary for the military secular service (i.e. flag)." },
        ],
        multipleSelect: false,
      },
      "7": {
        question: `What actions will be performed?`,
        options: [
          {
            text: `You will strictly follow the military funeral rituals`,
            conditions: {type: null, command: ""}, feedback: "Be sure to create a bulletin with the words and gestures included, so that those who are not familiar with a military secular ritual can follow along and participate.",
          },
          {
            text: `You will give community members a time to eulogize Bill`,
            conditions: {type: null, command: ""}, feedback: "It is a good idea to give community members a chance to share their reflections about Bill, or about loss more generally. Keep in mind that these reflections may not always seem relevant, but because one loss can bring up other losses in a person’s life, it is important for people to have the space to share."
          },
        ],
        multipleSelect: false,
      },
      "8": {
        question: `Where will the ritual be held?`,
        options: [
          { text: `A local church`, conditions: {type: "end", command: "SET_ACTIVE_SCENE"}, feedback: "Check with the church ahead of time regarding any accessibility issues, including the unique needs for members of the Sunday morning discussion group." },
          {
            text: `The space where the Sunday discussion group meets`,
            conditions: {type: "end", command: "SET_ACTIVE_SCENE"}, feedback: "This will likely be the most inviting, accessible space for those in the Sunday group."
          },
        ],
        multipleSelect: false,
      },
    };
    return data;
  } else if (action.type === "SOMETHING_ELSE") {
    let data = {
     "2": {
        question: `What kind of service will this be?`,
        options: [
          { text: `An interdenominational service`, conditions: {type: null, command: ""}, feedback: `An interdenominational service would be meaningful for those gathering, who come from a variety of faith backgrounds.` },
          { text: `A secular grief ritual`, conditions: {type: null, command: ""}, feedback: "A secular grief ritual respects Bill's tenuous relationship with religion."},
        ],
        multipleSelect: false,
      },
      "3": {
        question: `Where will the ritual be held?`,
        options: [
          { text: `A local church`, conditions: {type: null, command: ""}, feedback: "Check with the church ahead of time regarding any accessibility issues, including the unique needs for members of the Sunday morning discussion group."},
          {
            text: `The space where the Sunday discussion group meets`,
            conditions: {type: null, command: ""}, feedback: "This will likely be the most inviting, accessible space for those in the Sunday group."
          },
          { text: `Some other community space`, conditions: {type: null, command: ""}, feedback: "Check with this space ahead of time regarding any accessibility issues, including the unique needs for members of the Sunday morning discussion group." },
        ],
        multipleSelect: false,
      },
      "4": {
        question: `What words will be used?`,
        options: [
          {
            text: `You will use an interdenominational order of service`,
            conditions: {type: null, command: ""}, feedback: "Be sure to create a bulletin with the words and gestures included, so that participants can follow along."
          },
          {
            text: `You will write the service from scratch`,
            conditions: {type: null, command: ""}, feedback: "This might be a great opportunity to include the voices of the Sunday morning group, and  co-create a ritual together."
          },
        ],
        multipleSelect: false,
      },
      "5": {
        question: `What objects will be used?`,
        options: [
          {
            text: `Candles`,
            conditions: {type: null, command: ""}, feedback: "If there is someone who is particularly distressed by Bill’s passing, you could invite them to come early and light the candles as a special way to honor Bill."
          },
          { text: `Flowers`, conditions: {type: null, command: ""}, feedback: "Having fresh flowers can help to create a beautiful, calming environment."},
          { text: `Water`, conditions: {type: null, command: ""}, feedback: "Water is an object with important significance and meaning in many spiritualities." },
        ],
        multipleSelect: true,
      },
      "6": {
        question: `What actions will be performed?`,
        options: [
          {
            text: `Sprinkling ashes`,
            conditions: {type: null, command: ""}, feedback: "Sprinkling ashes in a particular location together with the community helps create a new sacred space."
          },
          {
            text: `Handing out flowers`,
            conditions: {type: null, command: ""}, feedback: "Receiving something at the service can be meaningful for those who attend, particularly if you are not making prayer cards or another object that commemorates him."
          },
        ],
        multipleSelect: false,
      },
      "7": {
        question: `Who will lead this service?`,
        options: [
          { text: `You, the chaplain`, conditions: {type: null, command: ""}, feedback: "Because you were Bill’s chaplain at the end of his life, you are an appropriate person to lead this service." },
          {
            text: `You and a group from Bill's Sunday morning discussion group`,
            conditions: {type: null, command: ""}, feedback: "Being part of a team creating the service may be empowering to members of the group, and could feel like a special way to honor Bill."
          },
        ],
        multipleSelect: false,
      },
      "8": {
        question: `What role will you play as the chaplain?`,
        options: [
          { text: `Officiant`, conditions: {type: null, command: ""}, feedback: "Because you were Bill’s chaplain at the end of his life, you are an appropriate person to lead this service." },
          {
            text: `Advisor to group of leaders from discussion group`,
            conditions: {type: null, command: ""}, feedback: "Being part of a team creating the service may be empowering to members of the group, and could feel like a special way to honor Bill."
          },
        ],
        multipleSelect: false,
      },
      "9": {
        question: `Who do you anticipate will attend?`,
        options: [
          { text: `Bill's Sunday morning discussion group`, conditions: {type: "end", command: "SET_ACTIVE_SCENE"}, feedback:"Because memorial services are at least as much a ritual for the living as the dead, consider who will most need a space to process Bill’s death. You might also consider inter- and intra-group dynamics. Are there places conflict or different needs for grieving might emerge?"  },
          { text: `The shelter group`, conditions: {type: "end", command: "SET_ACTIVE_SCENE"}, feedback:"Bill's peers at the shelter may be grieving his death and want a space to honor him."   },
          { text: `Other ministers who cared for Bill`, conditions: {type: "end", command: "SET_ACTIVE_SCENE"}, feedback:"Even though Bill had a tenuous relationship with religion, other ministers in Bill's life may wish to attend. "  },
        ],
        multipleSelect: true,
      },
    };
    return data;
  } else if (action.type === 'RESET_MEANING_DECISION_DATA'){
    let state = {
      "1": {
        question:
          "You sit down to begin planning Bill's memorial service. First, you must decide what type of service you should plan. Given Bill's background, there are a few obvious options.",
        options: [
          { text: "Roman Catholic funeral", conditions: {type: "dispatch", command: "ROMAN_CATHOLIC", index: "2"}, feedback: "A Roman Catholic funeral would perhaps have been a service that felt familiar to Bill, honoring his childhood faith tradition." },
          { text: "Military secular service", conditions: {type: "dispatch", command: "MILITARY", index: "2"}, feedback: "A military secular service would be a good way to honor Bill’s identity as a soldier and his distance from organized faith at the time of his death." },
          { text: "Something else", conditions: {type: "dispatch", command: "SOMETHING_ELSE", index: "2"}, feedback: "Good choice. Given Bill’s difficult relationships with Catholicism and the military, a less ritualized ceremony honors Bill’s values." },
        ],
        multipleSelect: false,
      },
      "2": {
  
      }
    };
     return state;
 } else return state;
};
export default sourceDecisionData;
